import * as React from 'react';
import { __ } from '@bart.sk-eshop/react-i18n/lib';
import {
  RegistrationHeading,
  RegistrationErrorPopup,
  RegistrationInput,
  RegistrationLabel,
  RegistrationFormCol,
  RegistrationFormRow,
} from './styles';
import { Field, Form } from 'react-final-form';
import { Loader } from '../_helpers/Loader/Loader';
import { required } from '../../utilities/validators';
import {
  onRegistrationSubmit,
  referRegistrationContactPersonSection,
  RegistrationProps,
  renderRegistrationAlert,
  renderRegistrationIcoInput,
  renderRegistrationPasswordInputs,
  renderRegistrationSubmitButton,
  renderRegistrationTermsCheckbox,
} from './constants';
import { connectSsr } from '@bart.sk-eshop/ssr-service';
import { connect } from 'react-redux';
import {
  loadSchoolIntroLess,
  loadSchoolIntroMore,
} from '../../containers/Registration/action';
import { OtherText, URL_REGISTRATION_COMPLETE_SCHOOL } from '../../constants';
import RegistrationIntro from './RegistrationIntro';
import { ChematCustomerType } from '../../library/ChematCustomerType';
import MetaTags from '../MetaTags/MetaTags';
import { loadGlobalMetaTags } from '../../utilities';

const metaUid = 'REG_SCHOOL';

interface RegistrationSchoolProps {
  schoolIntroLess: OtherText;
  schoolIntroMore: OtherText;
  globalMetaTags: any;
}

const RegistrationSchool = (
  props: RegistrationProps & RegistrationSchoolProps,
) => {
  const [submitting, setSubmitting] = React.useState(false);
  const [submitError, setSubmitError] = React.useState(undefined);
  const [showPassword, setShowPassword] = React.useState(false);

  const handlePasswordIcon = () => {
    setShowPassword(!showPassword);
  };

  const { dispatch, schoolIntroLess, schoolIntroMore, globalMetaTags } = props;

  const onSubmit = async (values) =>
    onRegistrationSubmit(
      dispatch,
      setSubmitting,
      setSubmitError,
      {
        email: values.contact_email,
        login: values.ico,
        ico: values.ico,
        password: values.password,
        password_again: values.password_confirm,
        skvelko_type: ChematCustomerType.SCHOOL,
        company_name: values.school_name,
        contact_name: values.contact_name,
        phone: values.contact_phone,
        lang: 'sk',
      },
      URL_REGISTRATION_COMPLETE_SCHOOL,
    );

  const renderSchoolNameInput = () => (
    <Field name="school_name" validate={required}>
      {({ input, meta }) => (
        <RegistrationFormCol>
          <RegistrationLabel htmlFor="school_name">
            {__('Názov školského zariadenia')}:
          </RegistrationLabel>
          <RegistrationInput {...input} type="text" />
          {meta.error && meta.touched && (
            <RegistrationErrorPopup>{meta.error}</RegistrationErrorPopup>
          )}
        </RegistrationFormCol>
      )}
    </Field>
  );

  return (
    <>
      {globalMetaTags[metaUid] ? (
        <MetaTags tags={globalMetaTags[metaUid]} />
      ) : (
        <MetaTags tags={{ title: 'Daffer.sk - Registrácia' }} />
      )}
      <Loader loading={submitting}>
        <RegistrationHeading>{__('Výhody registrácie')}:</RegistrationHeading>
        <RegistrationIntro
          dispatch={dispatch}
          loadLess={loadSchoolIntroLess}
          loadMore={loadSchoolIntroMore}
          textLess={schoolIntroLess}
          textMore={schoolIntroMore}
        />
        <RegistrationHeading>{__('Registračný formulár')}:</RegistrationHeading>
        {renderRegistrationAlert(submitError)}
        <Form
          onSubmit={onSubmit}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <RegistrationFormRow>
                {renderSchoolNameInput()}
                {renderRegistrationIcoInput()}
              </RegistrationFormRow>

              {renderRegistrationPasswordInputs(
                handlePasswordIcon,
                showPassword,
              )}

              {referRegistrationContactPersonSection()}

              {renderRegistrationTermsCheckbox(dispatch)}

              {renderRegistrationSubmitButton()}
            </form>
          )}
        />
      </Loader>
    </>
  );
};

RegistrationSchool.getInitialProps = async (parentProps) => {
  const { dispatch } = parentProps;
  const promises: any[] = [];

  promises.push(dispatch(loadGlobalMetaTags(metaUid)));

  await Promise.all(promises);
};

const mapStateToProps = (state) => {
  return {
    schoolIntroLess: state.registration.schoolIntroLess,
    schoolIntroMore: state.registration.schoolIntroMore,
    globalMetaTags: state.general.globalMetaTags,
  };
};

export default connect(mapStateToProps)(
  connectSsr({ displayName: 'RegistrationSchool' })(RegistrationSchool),
);
